import { Link } from "react-router-dom";

interface TagProps {
  label: string;
  href?: string;
  tone?: "accent" | "secondary" | "primary" | "muted";
}

const toneClass: Record<string, string> = {
  accent: "bg-accent-100 text-accent-900 hover:bg-accent-200",
  secondary: "bg-secondary-100 text-secondary-900 hover:bg-secondary-200",
  primary: "bg-primary-100 text-primary-800 hover:bg-primary-200",
  muted: "bg-background-200 text-foreground-700 hover:bg-background-300",
};

export default function Tag({ label, href, tone = "muted" }: TagProps) {
  const cls = `inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium transition-colors ${toneClass[tone]}`;
  if (href) {
    return (
      <Link to={href} className={`${cls} cursor-pointer`}>
        {label}
      </Link>
    );
  }
  return <span className={cls}>{label}</span>;
}